const GatewayTabs = () => {
	const togglePaymentDetailsSection = () => {
		const gutenbergPaymentDetailsWrapper = document.querySelector('.levcharity-donation-checkout-payment-details-container'),
			elementorPaymentDetailsWrapper = document.querySelector('.e-checkout__order_review-2'),
			activeGateway = document.querySelector('.levcharity-gateway-tab.active');
		if(!activeGateway){
			if(gutenbergPaymentDetailsWrapper) {
				gutenbergPaymentDetailsWrapper.classList.add('no-details');
			} else if(elementorPaymentDetailsWrapper) {
				elementorPaymentDetailsWrapper.classList.add('no-details');
			}
			return;
		}

		const dataId = activeGateway.getAttribute('data-id');
		if(dataId.includes('levit_paypal') || dataId.includes('levit_mollie') || dataId.includes('levit_yaadpay')) {
			// hide payment details section for these gateways
			if(gutenbergPaymentDetailsWrapper) {
				gutenbergPaymentDetailsWrapper.classList.add('no-details');
			} else if(elementorPaymentDetailsWrapper) {
				elementorPaymentDetailsWrapper.classList.add('no-details');
			}
		} else {
			if(gutenbergPaymentDetailsWrapper) {
				gutenbergPaymentDetailsWrapper.classList.remove('no-details');
			} else if(elementorPaymentDetailsWrapper) {
				elementorPaymentDetailsWrapper.classList.remove('no-details');
			}
		}
	};

	document.addEventListener('click', function(e) {
		if(!(e.target.matches('.levcharity-gateway-tab') || e.target.matches('.levcharity-gateway-tab *'))) {
			return;
		}
		// Check if the clicked element already has the 'active' class
		if (e.target.classList.contains('active')) {
			return;
		}

		// Remove 'primary_button' and 'active' classes from all tabs
		document.querySelectorAll('.levcharity-gateway-tab').forEach(function(tab) {
			tab.classList.remove('active');
		});

		// Add 'primary_button' and 'active' classes to the clicked tab
		e.target.classList.add('active');

		// Get the data-id of the clicked tab
		const dataId = e.target.getAttribute('data-id');

		// Find the label with the 'for' attribute matching the data-id and trigger a click
		const label = document.querySelector('label[for="' + dataId + '"]');
		togglePaymentDetailsSection();

		if (label) {
			label.click();
		}
	});

	document.addEventListener('levcharity_fragments_refreshed', function() {
		togglePaymentDetailsSection();
	});

	togglePaymentDetailsSection();
}

export default GatewayTabs;
